import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getBulletColorForScore } from '../../../common/utils';
import { WEB_COMPONENT_GZ_RM_SEVERITY_BAR } from '../../../../webcomponents.constants';
import { styles } from '../view/styles';

@customElement(WEB_COMPONENT_GZ_RM_SEVERITY_BAR)
export class GzRmSeverityBar extends LitElement {
  @property({ type: Number, attribute: true, reflect: true })
  score?: number = undefined;

  static get styles() {
    return styles;
  }

  protected render(): TemplateResult {
    const color = this.score ? getBulletColorForScore(this.score) : 'var(--grey-layout-202-disabled-icons)';
    const barValue = this.score ?? 0;

    return html`
      <gz-progress valuenow="${barValue}" valuemax="100" progressColor="${color}"></gz-progress>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [WEB_COMPONENT_GZ_RM_SEVERITY_BAR]: GzRmSeverityBar;
  }
}
